import { brickCarrouselActualites } from './bricks/brick_carrousel_actualites';
import { brickFaq } from './bricks/brick_faq';
import { brickGalerie } from './bricks/brick_galerie';
import { brickTemoignages } from './bricks/brick_temoignages';
import { brickVideo } from './bricks/brick_video';
import { brickCarrouselImages } from './bricks/brick_carrousel_images';
import { brickCarrouselLogos } from './bricks/brick_carrousel_logos';

// ----------------------------------- DOCUMENT READY -----------------------------------
// --------------------------------------------------------------------------------------
jQuery(function () {
    if ($('body').hasClass('propulse-bricks')) {
        if ($('.brick-carrousel-actualites').length) {
            brickCarrouselActualites.init();
        }
        if ($('.brick-faq').length) {
            brickFaq.init();
        }
        if ($('.brick-galerie').length) {
            brickGalerie.init();
        }
        if ($('.brick-temoignages').length) {
            brickTemoignages.init();
        }
        if ($('.brick-video').length) {
            brickVideo.init();
        }
        if ($('.brick-carrousel-images').length) {
            brickCarrouselImages.init();
        }
        if ($('.brick-carrousel-logos').length) {
            brickCarrouselLogos.init();
        }
    }
});